import { useQuery } from '@apollo/client';
import { GET_LISTING_AMOUNT_DISTRIBUTION_PER_PUBBLICATION_DATE } from 'apollo-client/queries/getListingAmountDistributionPerPubblicationDate';
import { HorizontalBarGraph } from 'components/HorizontalBarGraph';
import { GetListingAverageSellingTimeForCarBodiesRequest, Query } from 'generated/graphql';
import * as duration from 'duration-fns';
import { IntlShape, useIntl } from 'react-intl';
import { country } from 'cache';

const ISO8601DurationParser = (ISO8601Duration: string, formatMessage: IntlShape['formatMessage']): string => {
  const parsedDuration = duration.parse(ISO8601Duration);
  return (
    Object.keys(parsedDuration)
      .map((key) => {
        if (parsedDuration[key as keyof typeof parsedDuration] > 0)
          return formatMessage({ id: parsedDuration[key as keyof typeof parsedDuration] + key });
        return null;
      })
      .flat()
      .filter((x) => x)?.[0] ?? ''
  );
};

export const DistributionPerPUbblicationDate: (p: { vendorNames: Array<string> }) => JSX.Element | null = ({
  vendorNames,
}) => {
  const { formatMessage } = useIntl();
  const { loading, data } = useQuery<Query, GetListingAverageSellingTimeForCarBodiesRequest>(
    GET_LISTING_AMOUNT_DISTRIBUTION_PER_PUBBLICATION_DATE,
    { variables: { vendorNames, country: country() } }
  );
  return (
    <HorizontalBarGraph
      loading={loading}
      color="SECONDARY"
      barSeriesName={formatMessage({ id: 'amountDistributionPerPublicationDate' })}
      title={formatMessage({ id: 'amountDistributionPerPublicationDate' })}
      data={
        data?.getListingAmountDistributionPerPublicationDate?.map(
          ({ publicationDateWeekRangeISO8601, amountOfListingsPerPeriod }) => ({
            x: ISO8601DurationParser(publicationDateWeekRangeISO8601, formatMessage),
            y: amountOfListingsPerPeriod,
          })
        ) || []
      }
    />
  );
};
